import { Grid, Stack } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CardPrimary from "../../components/Card/Card.Primary";

import { HeadingPrimary } from "../../components/Styles/Heading";
import config from "../../config/aws-exports";
import { session } from "../../redux/Session/Session";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import CardSecondary from "../../components/Card/Card.Secondary";
import emptysearch from "../../assets/Nothing here yet.gif";
import AppBarLandingPage from "../../components/AppBar/AppBar.landingPage";
import SignInAndSignUp from '../../components/SignInAndSignUp/SignInAndSignUp';
import { useRef,useState } from "react";
export default function PreViewAll() {
  const dispatch = useDispatch();
  const { type, header, data } = useSelector(
    (state) => state.sessionViewAll.value,
  );
  const [loginOpen, setLoginOpen] = useState(false);
  console.log("type---",type, header, data);
  const navigate = useNavigate();

  const onlySignUp = useRef(false);

  const handleLoginClickOpen = (prop) => () => {
    console.log("prop",prop);
    if (prop === "login") {
      setLoginOpen(true);
      onlySignUp.current = false;
    } else {
      setLoginOpen(true);
      onlySignUp.current = true;
    }
  };
  return (
    <>
      <AppBarLandingPage handleLoginClick={handleLoginClickOpen} />
      <Stack spacing={3} margin={{ xs: "1rem", sm: "3rem" }}>
        <HeadingPrimary>{header}</HeadingPrimary>
        <Grid spacing={2} container>
          {data?.map((item, idx) => {
            return (
              <Grid item xs={12} sm={6} md={4} lg={type === "session" ? 3 : 4}>
                {console.log("item?.sn",item?.sn)}
                {type === "session" ? (
                  <CardPrimary
                    key={idx + "UKCsdf"}
                    auth={true}
                    title={item?.sn}
                    
                    img={
                      item.sid &&
                      `https://${
                        config.aws_cloudfront_url
                      }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                        item.sid
                      }.png`
                    }
                    addToBookMarkList={() => {}}
                    addToFavorite={item.EI}
                    sessionType={item.stype}
                    sessionDate={
                      moment(item?.date_list?.[0]?.date).format(
                        "DD MMM YYYY",
                      ) === "invalid date"
                        ? "Yet to be Scheduled"
                        : moment(item?.date_list?.[0]?.date).format(
                            "DD MMM YYYY",
                          )
                    }
                    handleLocation={() => {
                      navigate(`/session?sid=${item.sid}`);
                      dispatch(session(item));
                    }}
                  />
                ) : type === "myTopics" ? (
                  <CardSecondary
                    key={idx}
                    img={
                      item?.id &&
                      `https://${
                        config.aws_cloudfront_url
                      }/${config.aws_org_id.toLowerCase()}-resources/images/category-images/${
                        item?.ct_img
                      }`
                    }
                    title={item?.name}
                    handleLocation={() => {
                      navigate(`/preCourse?id=${item?.tid}`);
                      dispatch(session({ ...item }));
                    }}
                  />
                ) : (
                  <CardSecondary
                    key={idx}
                    img={
                      item?.tid &&
                      `https://${
                        config.aws_cloudfront_url
                      }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                        item?.tid
                      }.png`
                    }
                    title={item?.ttitle}
                    sessionDate={
                      item.startdate &&
                      moment(parseInt(item.startdate)).format("DD MMM YYYY")
                    }
                    handleLocation={() => {
                      navigate(`/preCourse?id=${item?.tid}`);
                      dispatch(session({ ...item }));
                    }}
                    nonug={item?.noofnuggets}
                  />
                )}
              </Grid>
            );
          })}
        </Grid>
        {data?.length === 0 ? (
          <div
            style={{
              height: "60vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <img src={emptysearch} alt="emptysearch" />
          </div>
        ) : null}
         {loginOpen && (
            <SignInAndSignUp
              loginOpen={loginOpen}
              setLoginOpen={setLoginOpen}
              onlySingUp={onlySignUp}
            />
          )}
      </Stack>
    </>
  );
}
